import Store from 'repatch';
import State from '../core/State';
import { createPath, History } from 'history';
import mergeUrlQuery from '../utility/mergeUrlQuery';
import {
  setLastAccessedOrganization,
  startFetchingLastAccessedOrganization,
  finishFetchingLastAccessedOrganization,
} from '../thunk/lastAccessedOrganization';
import { lastAccessedOrganizationVar } from '../cache';
import OrganizationWebApi from '../service/persistent/OrganizationWebApi';
import ApiErrorHandler from '../service/ApiErrorHandler';

class OrganizationUsecase {
  private readonly store: Store<State>;
  private readonly history: History;
  private readonly organizationWebApi: OrganizationWebApi;
  private readonly apiErrorHandler: ApiErrorHandler;

  constructor({
    store,
    history,
    organizationWebApi,
    apiErrorHandler,
  }: {
    store: Store<State>;
    history: History;
    organizationWebApi: OrganizationWebApi;
    apiErrorHandler: ApiErrorHandler;
  }) {
    this.store = store;
    this.history = history;
    this.organizationWebApi = organizationWebApi;
    this.apiErrorHandler = apiErrorHandler;
  }

  public setLastAccessedOrganization = async (orgId?: string): Promise<void> => {
    const state = this.store.getState();
    const query = new URLSearchParams(state.location.search);
    const lastAccessedOrganization = state.lastAccessedOrganization.item;
    const __future__replace__lastAccessedOrganization = lastAccessedOrganizationVar(); // replace repatch in the future
    const organizations = state.availableOrganizations.items;
    // get path
    const getOrganizationFromUrlPath = () => {
      let paths = location.pathname.split('/');
      for (let i = 0; i < paths.length; i++) {
        if (paths[i] === 'organizations' || paths[i] === 'users') {
          return i + 1 < paths.length ? paths[i + 1] : '';
        }
        //以下3行：エクスペリエンス一覧リニューアル後削除
        if (paths[i] === 'users_b') {
          return i + 1 < paths.length ? paths[i + 1] : '';
        }
      }
      return '';
    };

    const organizationId = orgId
      ? orgId
      : query.get('org')
      ? query.get('org')
      : getOrganizationFromUrlPath()
      ? getOrganizationFromUrlPath()
      : lastAccessedOrganization
      ? lastAccessedOrganization.id
      : __future__replace__lastAccessedOrganization
      ? __future__replace__lastAccessedOrganization.id
      : organizations.length
      ? organizations[0].id
      : null;

    if (!organizationId) {
      return;
    }
    const isNoItem = !organizations.find((organization) => organization.id === organizationId);

    if (isNoItem) {
      // king meaningless code since organizationId checks organizations[0]
      this.store.dispatch(setLastAccessedOrganization(organizations[0]));
      return;
    }

    if (lastAccessedOrganization?.id !== organizationId) {
      this.store.dispatch(startFetchingLastAccessedOrganization());

      try {
        const defaultOrganization = await this.organizationWebApi.getStubById(organizationId);
        const organization = organizations.find(({ id }) => id === organizationId);
        this.store.dispatch(setLastAccessedOrganization(organization ? organization : defaultOrganization));
      } catch (error) {
        this.apiErrorHandler.handle(error);
      }

      this.store.dispatch(finishFetchingLastAccessedOrganization());
    }
  };

  public setOrganizationIdToURL = async (): Promise<void> => {
    const state = this.store.getState();
    const lastAccessedOrganization = state.lastAccessedOrganization.item;
    const organizations = state.availableOrganizations;
    const organizationId = lastAccessedOrganization
      ? lastAccessedOrganization.id
      : organizations.items[0]
      ? organizations.items[0].id
      : null;

    if (this.history.location.pathname.match('/engine/comment-board/.+')) {
      return;
    }
    if (this.history.location.pathname.match('/users_b/.+')) {
      return;
    }

    organizationId && this.history.push(createPath(mergeUrlQuery(this.history.location, { org: organizationId })));
  };
}

export default OrganizationUsecase;
